import { useState, useEffect, useCallback } from 'react';
import { getVehicleFiSummary } from '../../../../../services/financeInsurance';

// Helper function to check if body is empty
const isBodyEmpty = (body) => {
  if (!body) return true;
  if (Array.isArray(body)) return body.length === 0;
  if (typeof body === 'object') return Object.keys(body).length === 0;
  return false;
};

export const useVehicleFiSummary = (partyUuid, vehicleUuid) => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isEmpty, setIsEmpty] = useState(false);

  const fetchSummary = useCallback(async () => {
    if (!partyUuid || !vehicleUuid) {
      return;
    }

    setLoading(true);
    setError(null);
    setIsEmpty(false);

    try {
      const response = await getVehicleFiSummary({
        party_uuid: partyUuid,
        vehicle_uuid: vehicleUuid,
      });

      const responseStatusCode = response?.statusCode;
      const isValidResponse = responseStatusCode === 200 || responseStatusCode === 201;

      if (!isValidResponse) {
        const errorMessage = response?.msgCode?.[0]?.description || 'Invalid response status code';
        throw new Error(errorMessage);
      }

      const body = response?.body;
      
      if (isBodyEmpty(body)) {
        setIsEmpty(true);
        setSummary(null);
      } else {
        const summaryData = Array.isArray(body) && body.length > 0 ? body[0] : body;
        setIsEmpty(false);
        setSummary(summaryData);
      }
    } catch (err) {
      console.error('Error fetching vehicle FI summary:', err);
      setError(err);
      setSummary(null);
      setIsEmpty(false);
    } finally {
      setLoading(false);
    }
  }, [partyUuid, vehicleUuid]);

  useEffect(() => {
    if (partyUuid && vehicleUuid) {
      fetchSummary();
    }
  }, [partyUuid, vehicleUuid, fetchSummary]);

  return {
    summary,
    loading,
    error,
    isEmpty,
    refetch: fetchSummary,
  };
};

